import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.path == from.path)
      return false;
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/home',
      props: true,
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ './views/Home.vue') // Lazy loaded
    },
    {
      path: '/:first/*',
      props: (route) => ({ voucher_code: route.query.voucher_code, product_id: route.query.product_id }),
      name: 'content',
      component: () => import(/* webpackChunkName: "about" */ './views/Channel.vue') // Lazy loaded
    },
    {
      path: '/*',
      props: (route) => ({ voucher_code: route.query.voucher_code, product_id: route.query.product_id }),
      name: 'content-wild',
      component: () => import(/* webpackChunkName: "about" */ './views/Channel.vue') // Lazy loaded
    },
  ]
})